import { useState, useEffect, useRef } from 'react';
import { execSeatableSql } from './seatable.js';
import AllImg from './allimg.js';
import * as consts from '../consts.js';
import SectionHeader from './sectionheader.js';

function Services(props) {
    const [data, setData] = useState(null);
    const [functionData, setFunctionData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT \`Desc\`, \`fnMediaLink\` FROM \`Capability Service\` WHERE \`Capability\` = '${props.capability}'`;
        setData(null);

        const functionSql = `SELECT \`Function\`, \`CapabilityService\` FROM \`CapabilityServiceFunction\` WHERE \`Capability\` = '${props.capability}' LIMIT 1000`;
        setFunctionData(null);

        try {
          const rows = await execSeatableSql(sql);
          setData(rows && rows.results);

          const functionRows = await execSeatableSql(functionSql);
          setFunctionData(functionRows && functionRows.results);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]);

    const getFunctions = (capabilityService) => {
        return functionData && functionData.filter(f => {return f.CapabilityService[0].display_value === capabilityService})
    }

return <>
        {data && (data.length > 0) ? <>
            <div id="Services" className='nav-margin'>
                <SectionHeader capability={props.capability} section="Services"/>
            </div>
            <div className="services pb-5 border-bottom border-secondary" >
                {data && data.map((row, index) => {
                    return (
                        <Service key={index} row={row} index={index} fdata={getFunctions(row.Desc)} />
                    )
                })}
            </div>
        </> : ''}
    </>
}

function Service(props) {
    const contentRef = useRef(null);
    const [showExpand, setShowExpand] = useState(true);
    const [toggleExpand, setToggleExpand] = useState(false);

    const handleBtnClick = () => {
        setToggleExpand(!toggleExpand)
    } 

    useEffect(() =>  {
        setShowExpand(toggleExpand || (contentRef && contentRef.current && (contentRef.current.scrollHeight > contentRef.current.clientHeight)))
    }, [toggleExpand, contentRef && contentRef.current && contentRef.current.clientHeight])

    return (<div>
        <div key={toggleExpand} className={`service`}>
            <div className="ms-auto my-3" style={{minWidth: "30px", minHeight: "10px", backgroundColor: `${consts.colorPalette[props.index%9]}`}}></div>
            <div className="d-flex align-items-center justify-content-center">
                <AllImg className='card-icon' src={props.row.fnMediaLink} alt={props.row.Desc} />
            </div>
            <h4 className="text-center my-3">{props.row.Desc}</h4>
            <div ref={contentRef} className={`card-content  ${toggleExpand ? 'card-expanded' : ''}`}>
                <ul>
                    {props.fdata?.map((frow, fidx) => {
                        return (
                            <li key={fidx} className="mb-2 pb-1 border-bottom border-secondary">{frow.Function}</li>
                        )
                    })}
                </ul>
            </div>
            <div className={`mt-auto ms-auto card-btn ${showExpand ? 'd-block' : 'd-none'}`} onClick={handleBtnClick} >
                <i className={`bi bi-arrow-${toggleExpand ? 'up' : 'down'}-circle`}></i>
            </div>
        </div>
    </div>)
}

export default Services;